import { Currency } from "@redotech/money/currencies";
import * as z from "zod/v4";

const timeSeriesMetric = z.array(
  z.object({ plainDate: z.string(), value: z.number().optional() }),
);

export const getWidgetsTimeSeriesMetrics = {
  name: "getWidgetsTimeSeriesMetrics" as const,
  input: z.null(),
  output: z.object({
    incrementalRevenueOverTimeSeries: timeSeriesMetric,
    currency: z.enum(Currency),
  }),
};
